<template>
  <div class="newdetail_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ data.title }}
      </div>
    </div>
    <div class="ctn">
      <!-- <vue-editor v-model="data.content" style="display: none"/> -->
      <div
        class="contract_box"
        v-html="data.content"
      />
    </div>
  </div>
</template>

<script>

    import Fetch from "../../utils/fetch";
	import bsHeader from '../../components/bsHeader.vue'

    export default {
        name: "Aritcle",
        components: {bsHeader},
        data() {
            return {
                data: {},
            };
        },
        created() {
            this.$parent.footer('user',false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/article_detail', {
                    id: this.$router.history.current.params.code
                }).then(res => {
                    this.data = res.data;
                })
            },
        }
    };
</script>

<style lang="less" scoped>
    
	
    .newdetail_wrap {
        overflow-x: hidden;
        overflow-y: auto;
        min-height: 100vh;
        background: #f5f5f5;
    }

    .newdetail_wrap .ctn {
        width: 100%;
        background: #fff;
		margin-top: 10px;
        padding: 0;
    }
	.contract_box{
		line-height: 1.7;
		padding: 18px 16px;
	}

    .newdetail_wrap .ctn .title {
        font-size: 12px;
        color: #333;
        font-weight: bold;
        line-height: 1.7;
    }

    .newdetail_wrap .ctn .info {
        font-size: 12px;
        color: #333;
        line-height: 1.7;
    }

	.red_top_bg { height: 50px; position: relative; background: #fff; border-bottom: 1px solid #eee; }
	.back_left { filter: brightness(0); opacity: 1; }
	.big_tit { top: 13px; max-width: 70%; overflow: hidden; color: #333; font-size: 16px; font-weight: 500; text-overflow: ellipsis; white-space: nowrap; }
</style>
